// Remote H5 repair for existing full-window HTML5+ Android shells.
export function syncAndroidSafeArea() {
  const style = document.documentElement.style;
  let overlap = 0;
  try {
    const runtime = window.plus;
    if (runtime?.os?.name === 'Android' && runtime.navigator.isImmersedStatusbar()) {
      const height = runtime.navigator.getStatusbarHeight();
      let view = runtime.webview.currentWebview();
      let offset = 0;
      const visited = new Set();
      // An already-offset child or parent must not reserve the status bar twice.
      while (view) {
        if (visited.has(view)) throw new Error('Invalid WebView hierarchy');
        visited.add(view);
        const layout = view.getStyle();
        const top = String(layout.top ?? 0);
        if (!/^\d+(?:\.\d+)?(?:px)?$/.test(top) || layout.titleNView) throw new Error('Unmeasured WebView layout');
        offset += parseFloat(top);
        view = view.parent();
      }
      if (Number.isFinite(height) && height > 0) overlap = Math.max(0, height - offset);
    }
  } catch (_) { /* Unsupported runtimes retain the existing native/CSS safe area. */ }
  if (overlap > 0) {
    // Separate property: an older shell may subsequently inject native top:0.
    style.setProperty('--android-safe-area-top', `max(var(--native-safe-area-top, env(safe-area-inset-top, 0px)), ${overlap}px)`);
  } else {
    style.removeProperty('--android-safe-area-top');
  }
}

export function installAndroidSafeArea() {
  syncAndroidSafeArea();
  document.addEventListener('plusready', syncAndroidSafeArea);
  document.addEventListener('resume', syncAndroidSafeArea);
  window.addEventListener('resize', syncAndroidSafeArea);
  window.addEventListener('pageshow', syncAndroidSafeArea);
}
